import * as constants from '@/store/constants'
import * as utils from '@/mixins/utils'
import * as types from '@/store/types'
import service from '@/api/MofaService'
import store from '@/store'

export default {
    [types.ACTION_ADD_MOFA]: ({commit}, payload) => {
    	const type = utils.findMofaNameById( payload.request_type_id )
    	service.addMofa(payload, type)
               .then( (response) => {
                   if (response) {
                       store.commit(types.MUTATE_MOFA, response)
                       store.commit(types.MUTATE_MODIFIED, false)

                       if (store.state.submittedId == 0) {
                           store.commit(types.MUTATE_NEW_NOTIFICATION, false)
                       }
                   }
               })
    },
    [types.ACTION_UPDATE_MOFA]: ({commit}, payload) => {
    	const type = utils.findMofaNameById( payload.request_type_id )
        service.updateMofa(payload, type)
        	   .then( (response) => {                  
                   if (response) {
                       store.commit(types.MUTATE_MOFA, response)
                       store.commit(types.MUTATE_MODIFIED, false)                       
                   }
               })
    },
    [types.ACTION_FIND_MOFA]: ({commit}, payload) => {
      service.fetchByNotificationId(payload.id, payload.type)
    		.then( (response ) => {          
              if (response) {
                  console.log("** ACTION_FIND_MOFA **")
                  console.log(payload)
                  console.log("** Response **")
                  console.log(response)
                  commit(types.MUTATE_MOFA, response)
        		}
            })
    },
    // CENTCOM
    [types.ACTION_ADD_MOFA_CENTCOM]: ({commit}, payload) => {
        const type = utils.findMofaNameById( payload.request_type_id )
        service.addMofaCentcom(payload, type)
               .then( (response) => {
                   if (response) {
                       store.commit(types.MUTATE_MOFA_CENTCOM, response)
                       store.commit(types.MUTATE_MODIFIED, false)
                       store.commit(types.MUTATE_NEW_NOTIFICATION, false)
                   }
               })
    },
    [types.ACTION_UPDATE_MOFA_CENTCOM]: ({commit}, payload) => {
        const type = utils.findMofaNameById( payload.request_type_id )
        service.updateMofaCentcom(payload, type)
               .then( (response) => {                  
                   if (response) {
                       store.commit(types.MUTATE_MOFA_CENTCOM, response)
                       store.commit(types.MUTATE_MODIFIED, false)                       
                   }
               })
    },
    [types.ACTION_FIND_MOFA_CENTCOM]: ({commit}, payload) => {
      service.fetchCentcomByNotificationId(payload.id, payload.type)
            .then( (response ) => {          
              if (response) {
                  console.log("** ACTION_FIND_MOFA_CENTCOM **")
                  console.log("** Payload **")
                  console.log(payload)
                  console.log("** Response **")
                  console.log(response)
                  commit(types.MUTATE_MOFA_CENTCOM, response)
                }
            })
    }   
}


// WEBPACK FOOTER //
// ./src/store/modules/mofa/actions.js